import Image from 'next/image';
import { useRef, useState } from 'react';
import { LANGUAGE_ENUMS } from '../../../constants/staticPageConstants';

import { DemoModal } from '../../Atoms/DemoModal';
import { MarktechModal } from '../../Atoms/Modal';
import { CloseIcon } from '../../Icons';
import { useOnClickOutside } from '../../hooks';
import { DropdownComponent as LangSwitchDropDown } from '../DynamicHeader/Dropdown/DropdownComponent';
import { TDropdownList } from '../DynamicHeader/Dropdown/DropdownComponent';
import { HEADER_LABELS } from '../DynamicHeader/Dropdown/DropdownData';
import { GeneralDropdown } from '../DynamicHeader/Dropdown/DropdownOptionsComponent';

import { GeneralColDropdown } from '../../Navbar/ClearNavbar/Dropdown/GeneralDropdown';
import { DropdownComponent } from '../../Navbar/ClearNavbar/Dropdown/DynamicDropdown';
import {
  DropdownLanguageData,
  SA_SOLUTIONS_OPTIONS,
} from '../DynamicHeader/Dropdown/SADropdownComponent';
import { DOMAIN_PREFIX } from '../../../constants/staticPageConstants';

const myLoader = () => {
  return `https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d9f36ac3-77a9-40c6-94fc-20c2e3855457.svg`;
};

interface IProps {
  language: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  domain?: number;
}

const DesktopNavBar = ({
  language = LANGUAGE_ENUMS.English,
  LangSwitchLink,
  domain,
}: IProps): JSX.Element => {
  const modalRef = useRef(null);
  const [displayPopup, demoPopup] = useState(false);
  const header_labels = HEADER_LABELS[language as keyof typeof HEADER_LABELS];
  const isEnglishPage = language === LANGUAGE_ENUMS.English ? true : false;
  const direction = !isEnglishPage ? 'rtl' : 'ltr';
  const text = isEnglishPage ? 'Announcements' : 'الإعلانات';

  const pageLang = isEnglishPage
    ? LANGUAGE_ENUMS.English
    : LANGUAGE_ENUMS.Arabic;

  useOnClickOutside(modalRef, () => {
    demoPopup(false);
  });

  const commonAttributes = {
    domain: 'sa',
    language: language,
    classes: 'relative',
    hover: true,
    Dropdown: GeneralDropdown,
  };

  return (
    <>
      <div
        className="bg-white py-3 w-full fixed top-0 z-20 font-medium sm:px-0"
        style={{ direction: direction }}
        data-testid="Header"
      >
        <nav className="flex items-center text-s-14 z-20 md:w-full sm:w-full font-medium wg-container gap-1">
          <div
            className={`sm:w-full items-center bg-white inline-flex flex-grow w-auto z-50 sm:flex-row sm:shadow-sm`}
          >
            <a
              href={
                'https://www.' +
                  DOMAIN_PREFIX[domain as keyof typeof DOMAIN_PREFIX]?.domain ||
                'https://www.cleartax.com/sa'
              }
              className="inline-flex items-center pr-5 py-2"
            >
              <Image
                loader={myLoader}
                src="me.png"
                alt="Picture of the author"
                width={120}
                height={27}
              />
            </a>

            <div className="items-center justify-end gap-2 bg-white inline-flex flex-grow z-50 sm:w-full sm:flex-row sm:shadow-sm">
              <DropdownComponent
                dropdownLabel={header_labels.about_us}
                dropdownList={DropdownLanguageData[pageLang].aboutUs}
                Dropdown={GeneralColDropdown}
                hover={true}
              />
              <DropdownComponent
                dropdownLabel={header_labels.solutions}
                dropdownList={SA_SOLUTIONS_OPTIONS}
                Dropdown={GeneralColDropdown}
                hover={true}
              />
              <DropdownComponent
                dropdownLabel={header_labels.sa_resources}
                dropdownList={DropdownLanguageData[pageLang].resources}
                Dropdown={GeneralColDropdown}
                hover={true}
              />

              <div className="whitespace-no-wrap font-medium ml-4 md:mx-1 text-font-500 text-s-14 whitespace-no-wrap">
                <a
                  href="https://www.cleartax.com/sa/announcements"
                  className="text-inherit no-underline"
                >
                  {text}
                </a>
              </div>
            </div>
            <button
              type="button"
              className="font-medium flex w-auto py-2 rounded text-font-500 whitespace-nowrap mr-3"
              aria-expanded="true"
              aria-haspopup="true"
            >
              <a
                href="https://www.cleartax.com/sa/contact-us"
                rel="noreferrer"
                className="sm:text-s-12 text-font-500 pl-6"
              >
                {header_labels.contact_us}
              </a>
            </button>
          </div>
          <div
            className={`sm:w-full bg-white inline-flex flex-grow w-auto z-50 flex-row-reverse sm:flex-row sm:shadow-sm`}
          >
            <div className="flex items-center">
              <div className="relative w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto items-center flex sm:flex-col lg:h-auto xl:h-auto">
                <LangSwitchDropDown
                  dropdownLabel={header_labels.language}
                  dropdownList={LangSwitchLink as TDropdownList}
                  {...commonAttributes}
                />
                <div className="w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto  lg:items-center items-start  flex sm:flex-col lg:h-auto xl:h-auto">
                  <div
                    className="sm:px-0 sm:py-2 whitespace-nowrap cursor-pointer "
                    onClick={() => demoPopup(true)}
                  >
                    <span className="button button-bluefilled font-bold inline-flex items-center lg:w-auto rounded-lg text-base w-full whitespace-nowrap">
                      {header_labels.demo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="h-20"></div>
      <MarktechModal
        open={displayPopup}
        onClose={() => {}}
        classNames={{
          modal: 'md:w-11/12 sm:w-11/12 w-1/2 mobile-search-box rounded-2xl',
        }}
        closeIcon={<CloseIcon />}
        center
      >
        <DemoModal
          modalRef={modalRef}
          demoPopup={demoPopup}
          language={language}
          domain={domain}
        />
      </MarktechModal>
    </>
  );
};

export { DesktopNavBar };
